import { render } from "./BtnCertificate.vue?vue&type=template&id=50b6723e&ts=true&lang=pug"
import script from "./BtnCertificate.vue?vue&type=script&setup=true&lang=ts"
export * from "./BtnCertificate.vue?vue&type=script&setup=true&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__